import {
  DAY_SUMMARY_ALL,
  DAY_SUMMARY_GET,
  DAY_SUMMARY_PUT,
  DAY_SUMMARY_POST,
  DAY_SUMMARY_LOADING,
  DAY_SUMMARY_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const daySummaryCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: DAY_SUMMARY_LOADING });

    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/day-summary`,
      payload,
    );

    dispatch({ type: DAY_SUMMARY_POST, payload: data });

    // ✅ คืนค่ากลับไปให้ component ใช้ได้
    return data;
  } catch (error) {
    console.error('❌ daySummaryCreate error:', error);

    dispatch({ type: DAY_SUMMARY_ERROR });

    // ✅ โยน error กลับให้ component handle ต่อได้
    throw error.response?.data || error.message;
  }
};

export const daySummaryAll =
  (params = {}) =>
  async (dispatch) => {
    try {
      const { name = '', size = null, page = 1 } = params;
      const { data, status } = await api.get(
        `${process.env.REACT_APP_API_URL}/day-summary`,
      );
      if (status === 200) {
        dispatch({ type: DAY_SUMMARY_ALL, payload: data });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: DAY_SUMMARY_ERROR });
      throw new Error(error);
    }
  };

export const daySummaryGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/day-summary/${id}`,
    );
    if (status === 200) {
      dispatch({ type: DAY_SUMMARY_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: DAY_SUMMARY_ERROR });
    throw new Error(error);
  }
};

export const daySummaryPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: DAY_SUMMARY_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/day-summary/${id}`,
      payload,
    );
    dispatch({ type: DAY_SUMMARY_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: DAY_SUMMARY_ERROR });
    throw new Error(error);
  }
};
